module.exports = __webpack_public_path__ + "img/pic_50jifen2.cda566ab.png";